import axios from "axios"


export {statusReasonActions};

axios.defaults.withCredentials = true;

function statusReasonActions () {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getStatusReasons,
    getByCodeStatusReasons,
    exportDataStatusReason,
    createStatusReason,
    deleteStatusReason,
    editStatusReason,
    // CR LPP-20500 RF-13: gestione toggle status reason via availability service
    getStatusReasonImpactCount,
    toggleStatusReason,
  }


  async function exportDataStatusReason(tenant:string|undefined) {
    const exportAllDataStatusReason = await axios.get(
      `${baseUrl}/masterdatavehicle/statusreason/excel`,
      {
        params:{tenant:tenant},
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );

    return exportAllDataStatusReason;
  }

async function getStatusReasons(tenant:string|undefined, pageNumber: number, pageSize: number){
  const getAllStatusReasons = await axios.get(`${baseUrl}/masterdatavehicle/statusreason`,
  { params: {tenant:tenant, pageNumber: pageNumber, pageSize: pageSize} }
)

  return getAllStatusReasons
}

async function getByCodeStatusReasons(tenant:string|undefined,code: any){
  const getSelectedByCodeStatusReasons = await axios.get(`${baseUrl}/masterdatavehicle/statusreason/code/${code}`,{params:{tenant:tenant}})
         return getSelectedByCodeStatusReasons;
  
}


async function createStatusReason(tenant:string|undefined,createStatusReasonObject:any) {
  const createNewStatusReason = await axios.post(`${baseUrl}/masterdatavehicle/statusreason`, createStatusReasonObject,{params:{tenant:tenant}});
  return createNewStatusReason;

}

async function deleteStatusReason(tenant:string|undefined,id:any) {
  const deleteSelectedStatusReason = await axios.delete(`${baseUrl}/masterdatavehicle/statusreason/${id}`,{params:{tenant:tenant}});
  return deleteSelectedStatusReason;

}

async function editStatusReason(tenant:string|undefined,id:any,editStatusReasonObject: any) {
  const editSelectedStatusReason = await axios.put(`${baseUrl}/masterdatavehicle/statusreason/${id}`, editStatusReasonObject,{params:{tenant:tenant}});
  return editSelectedStatusReason;
}

// ─── CR LPP-20500 RF-13 — Toggle status reason via availability service ────
//
// Flusso:
//  1. FE chiama getStatusReasonImpactCount per il count veicoli impattati
//  2. FE mostra popup conferma con il numero
//  3. all'OK del popup, FE chiama toggleStatusReason con {confirmed: true}
//  4. al success, FE rilegge la singola status reason via getByCodeStatusReasons
//     (no optimistic update — verifica consistenza). Se errore: nessun cambio FE.
//
// Endpoints BFF allineati a `implementation-log-dario-SC.md` Punto 3:
//  - GET /sc-be/availability/statusReason/{reasonCode}/impactCount?tenant=
//  - PUT /sc-be/availability/statusReason/{reasonCode}/toggle?tenant=

async function getStatusReasonImpactCount(tenant: string | undefined, reasonCode: string) {
  const response = await axios.get(
    `${baseUrl}/availability/statusReason/${encodeURIComponent(reasonCode)}/impactCount`,
    { params: { tenant: tenant } }
  );
  return response.data as { reasonCode: string; currentStatus: string; targetStatus: string; impactedVehicleCount: number };
}

async function toggleStatusReason(tenant: string | undefined, reasonCode: string, confirmed: boolean) {
  const response = await axios.put(
    `${baseUrl}/availability/statusReason/${encodeURIComponent(reasonCode)}/toggle`,
    { confirmed: confirmed },
    { params: { tenant: tenant } }
  );
  return response.data as { reasonCode: string; previousStatus: string; newStatus: string; vehiclesUpdated: number };
}


}
